/* eslint-disable no-console */
import { Strophe } from 'react-strophe'
import { Chat } from './chatSettingsConfig'

export const isConnected = ({ connection }) => {
  return connection?.connected && connection?.authenticated && !connection?.disconnecting
}

export const configureLogging = ({ connection }) => {
  if (Chat.Settings.LOG_SERVER_INTERACTIONS && process.env.NODE_ENV !== 'production') {
    connection.xmlInput = (data) => {
      console.log(`%c[XMPP] Receiving data: ${Strophe.serialize(data)}`, 'color: blue; font-size: 10px')
    }

    connection.xmlOutput = (data) => {
      console.log(`%c[XMPP] Sending data: ${Strophe.serialize(data)}`, 'color: purple; font-size: 10px')
    }
  }
}
